// import {
//   RuleParamSchema,
//   Record,
// } from 'vee-validate'.types;

const validateImage = (file: File, width: number, height: number): Promise<boolean> => new Promise((resolve) => {
  const image = new Image();
  image.onerror = () => resolve(false);
  image.onload = () => {
    const r = image.width === width && image.height === height;
    resolve(r);
  };
  image.src = URL.createObjectURL(file);
});

const validate = (files: File | File[], { width, height }: Record<string, any>) => {
  // console.log('VALIDATE');
  const list = [];
  const fs = Array.isArray(files) ? files : [files];
  for (let i = 0; i < fs.length; i++) {
    // if file is not an image, reject.
    if (!/\.(jpg|svg|jpeg|png|bmp|gif)$/i.test(fs[i].name)) {
      return Promise.resolve(true);
    }

    list.push(fs[i]);
  }

  const rs = Promise.all(list.map((file) => validateImage(file, width, height)))
    .then((values) => values.every((v) => v));
  return rs;
};
const params: any[] = [
  {
    name: 'width',
    cast(value: any) {
      return Number(value);
    },
  },
  {
    name: 'height',
    cast(value: any) {
      return Number(value);
    },
  },
];

const message = (files: unknown, pms: any) => `画像は幅${pms.width}px：高さ${pms.height}pxでなければなりません`;
export {
  validate,
  message,
  params,
};

export default {
  message,
  validate,
  params,
};
